<template>
    <info-widget :collapsible="true" :is-expanded="expanded" @toggle_expand="$emit('toggle_expand')">
        <template v-slot:title>Earnings Statements</template>

        <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.PAYCHECKS_ROLES)">
            <div class="info-widget-empty p-2">
                This information is not available to your security role.
            </div>
        </slot>

        <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.PAYCHECKS_ROLES)">
            <div v-if="employee && checks.length">
                <section class="table-section">
                    <div class="table-wrapper table-responsive">
                        <table class="table css-table widget-table table-fixed">
                            <thead>
                                <tr>
                                    <th class="cw-checknum">Num</th>
                                    <th class="cw-7 cell-left">Date</th>
                                    <th class="cw-pay cell-right">Net Pay</th>
                                </tr>
                            </thead>
                            <tbody v-for="(check, i) in visibleChecks" :key="check.id" :class="{'active-item': check.id == activeCheckId}">
                                <tr>
                                    <td class="cw-checknum">
                                        <a href @click.prevent="onCheckClicked(check)">
                                            {{ check.earning_statement_number || '' }}
                                        </a>
                                    </td>
                                    <td class="cw-7 cell-left">
                                        <a href @click.prevent="onCheckClicked(check)">
                                            {{ $filters.dateshort(check.check_date) }}
                                        </a>
                                    </td>
                                    <td class="cw-pay cell-right">
                                        <span>
                                            ${{ check.net_pay }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
                <div v-if="!showAllChecks && employee && checks.length > 5" class="pb-1">
                    <button type="button" class="btn btn-link btn-block" @click.prevent="showAllChecks = true">
                        See all
                    </button>
                </div>
                <div v-if="showAllChecks && employee && checks.length > 5" class="pb-1">
                    <button type="button" class="btn btn-link btn-block" @click.prevent="showAllChecks = false">
                        See fewer
                    </button>
                </div>
            </div>
            <div v-if="!checks.length">
                <div class="info-widget-empty p-2">
                    This employee has no earnings statements.
                </div>
            </div>
        </slot>
    </info-widget>

    <earnings-statement-modal :client="client" :earnings-statement-id="currentCheck.id" :earning-types="earningTypes" v-if="currentCheck" ref="earningsStatementModal" @close="currentCheck = null" />
</template>

<script>
import ButtonRow from '@/components/ButtonRow'
import InfoWidget from '@/components/InfoWidget'
import EarningsStatementModal from '@/components/EarningsStatementModal'

export default {
    components: {ButtonRow, InfoWidget, EarningsStatementModal},
    props: ['employee', 'client', 'checks', 'activeCheckId', 'expanded', 'earningTypes'],
    emits: ['toggle_expand'],
    computed: {
        visibleChecks() {
            if (!this.showAllChecks) {
                return this.checks.slice(0, 5)
            }

            return this.checks
        },
    },
    data() {
        return {
            currentCheck: null,
            showAllChecks: Boolean(this.activeCheckId),
        }
    },
    methods: {
        onCheckClicked(check) {
            this.currentCheck = check
            this.$nextTick(() => {
                this.$refs.earningsStatementModal.open()
            })
        },
    },
}
</script>
